export const DISPOSE = '@receive/dispose';
export const SHOW_ADDRESS = '@receive/show-address';
export const SHOW_UNVERIFIED_ADDRESS = '@receive/show-unverified-address';
